module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./GiftWarehouseView.js"));
	}, "GiftWarehouseView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=GiftWarehouseView!./src/pages/Shop/Member/Personal/GiftWarehouse/GiftWarehouseView.js
// module id = 1016
// module chunks = 431